import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck,
  Users,
  Search,
  Target,
  Lock,
} from "lucide-react";

const trustMetrics = [
  {
    icon: Target,
    title: "100% Project Commitment",
    description:
      "Every website and SEO project receives full strategic focus from start to launch.",
  },
  {
    icon: Users,
    title: "100% Client-Centered Approach",
    description:
      "Transparent communication and structured project management.",
  },
  {
    icon: Search,
    title: "SEO-Optimized Architecture",
    description:
      "Built with performance, indexing, and long-term scalability in mind.",
  },
  {
    icon: ShieldCheck,
    title: "Conversion-Focused Design",
    description:
      "Websites engineered to turn traffic into measurable business results.",
  },
  {
    icon: Lock,
    title: "Secure & Scalable Development",
    description:
      "Modern frameworks built for performance and future growth.",
  },
];

export const TrustSection = () => {
  return (
    <section className="section-padding-sm bg-gradient-to-b from-muted/50 to-background relative overflow-hidden">
      {/* soft background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl opacity-60" />
        <div className="absolute -bottom-24 right-10 w-80 h-80 bg-secondary/10 rounded-full blur-3xl opacity-60" />
      </div>

      <div className="container-custom relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-10 sm:mb-14"
        >
          <span className="text-sm font-medium text-primary uppercase tracking-wider">
            WHY TRUST US
          </span>

          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mt-3 mb-5">
            Experience & Trust{" "}
            <span className="gradient-text">You Can Rely On</span>
          </h2>

          <p className="text-muted-foreground leading-relaxed">
            At Square Trigger, we focus on building websites and SEO strategies that
            create long-term digital assets. We don’t believe in shortcuts — we believe
            in structured execution, technical precision, and measurable outcomes.
          </p>
          <p className="text-muted-foreground leading-relaxed mt-4">
            Our commitment to performance, transparency, and client success defines how
            we approach every project.
          </p>
        </motion.div>

        {/* Metrics grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
          {trustMetrics.map((m, index) => {
            const Icon = m.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.06 }}
                whileHover={{ y: -4 }}
                className="h-full p-5 sm:p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-medium transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl gradient-primary-soft flex items-center justify-center mb-4">
                  <Icon className="h-6 w-6 text-primary" />
                </div>

                <div className="font-display font-semibold text-foreground mb-2">
                  {m.title}
                </div>

                <p className="text-sm text-muted-foreground leading-relaxed">
                  {m.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};